export default __webpack_public_path__ + "static/media/boxtype13.09dcd119.JPG";